import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MeetingsStatisticsAPI from '../../../api/MeetingsStatisticsAPI';
import BarChart from '../../../components/BarChart/BarChart';
import NoData from '../../../components/NoData/NoData';

type Props = {
  timeRange: { start: string; end: string };
};

type SeriesPoint = { label: string; count: number };

function MeetingsTotalOverTime({ timeRange }: Props) {
  const { t } = useTranslation();
  const [series, setSeries] = useState<SeriesPoint[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await MeetingsStatisticsAPI.getMeetingsTotalOverTime({ startTime: timeRange.start, endTime: timeRange.end });
        const pts = (res.data?.labels || []).map((label: string, idx: number) => ({ label, count: res.data.values[idx] }));
        setSeries(pts);
      } catch (e) {
        setSeries([]);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end]);

  if (!series.length) return <NoData message={t('global.empty_results')} />;

  return (
    <BarChart
      title={t('stats.meetings_total_over_time') || 'Meetings over time'}
      xLabels={series.map((p) => p.label)}
      dataSets={[{
        label: t('stats.meetings') || 'Meetings',
        data: series.map((p) => p.count),
        backgroundColor: ['rgba(99, 102, 241, 0.6)'],
        borderColor: ['rgba(99, 102, 241, 0.6)'],
        borderWidth: 1,
      }]}
    />
  );
}

export default MeetingsTotalOverTime;


